import { type RefObject, useEffect, useState } from 'react';

type UseEditPageScaleParams = {
  wrapper: RefObject<HTMLElement>;
  content: RefObject<HTMLElement>;
};

export const useEditPageScale = ({
  wrapper: wrapperRef,
  content: contentRef,
}: UseEditPageScaleParams) => {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const calculateScale = (): void => {
      const wrapper = wrapperRef.current;
      const content = contentRef.current;

      if (!wrapper || !content) {
        return;
      }

      const wrapperRect = wrapper.getBoundingClientRect();

      const contentWidth = content.offsetWidth;
      const pageHeight = (contentWidth * 9) / 16;

      const scaleX = wrapperRect.width / contentWidth;
      const scaleY = wrapperRect.height / pageHeight;

      const newScale = Math.min(scaleX, scaleY, 1);

      setScale(newScale);
    };

    calculateScale();

    const resizeObserver = new ResizeObserver(calculateScale);

    if (wrapperRef.current) {
      resizeObserver.observe(wrapperRef.current);
    }

    if (contentRef.current) {
      resizeObserver.observe(contentRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [wrapperRef, contentRef]);

  return scale;
};
